import { useEffect, useState } from 'react';

/** Long enough for the last row's delay plus its transition. */
const ENTRY_MS = 1400;

/**
  * True only while a panel is playing its one-time entry cascade.
  *
  * The per-row transition delay that staggers the entry must not survive it:
  * left in place, releasing a hover replays the cascade and the rows return to
  * full opacity one at a time instead of together.
  *
  * The entry phase ends on a timer, or immediately on the first hover, so even
  * a hover during the entry animation leaves cleanly.
  */
export default function useEntryStagger(shown, hover) {
    const [entered, setEntered] = useState(false);

    useEffect(() => {
        if (!shown) {
            setEntered(false); // rearm, so returning to the panel animates again
            return undefined;
        }
        const t = setTimeout(() => setEntered(true), ENTRY_MS);
        return () => clearTimeout(t);
    }, [shown]);

    useEffect(() => {
        if (hover != null) setEntered(true);
    }, [hover]);

    return shown && !entered;
}
